import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, fetchAll } from "@/lib/apiClient";
import { contactEmail } from "@/lib/contact";
import { AdminTable, DateTimeCell, toWhatsAppLink, SignInBadges, signInLabel } from "./lib";
import { MessageCircle } from "lucide-react";

const GRID = "grid-cols-[minmax(150px,1fr)_minmax(190px,1.2fr)_140px_130px_120px]";
const COLUMNS = [
  { key: "name", label: "Name" },
  { key: "email", label: "Email" },
  { key: "mobile", label: "Mobile" },
  // A customer has no password, so the provider *is* how they get in — see SignInBadges.
  { key: "signin", label: "Sign-in" },
  { key: "joined", label: "Joined" },
];

export function AdminUsers() {
  const nav = useNavigate();
  const [rows, setRows] = useState([]);
  useEffect(() => { fetchAll("/admin/users").then(setRows).catch(() => {}); }, []);
  return (
    <div className="space-y-6" data-testid="admin-users-page">
      <h1 className="font-serif-display text-3xl md:text-4xl text-white">Registered Users</h1>
      <AdminTable
        testid="admin-users" columns={COLUMNS} gridCols={GRID} rows={rows}
        defaultSort="joined" empty="No customers yet."
        searchPlaceholder="Search name, email, mobile, Google/Facebook…"
        matches={(u, q) => [u.name, u.email, u.contact_email, u.mobile, signInLabel(u)]
          .filter(Boolean).join(" ").toLowerCase().includes(q)}
        accessors={{
          name: (u) => (u.name || "").toLowerCase(),
          email: (u) => contactEmail(u).toLowerCase(),
          mobile: (u) => u.mobile || "",
          // Sorts and searches on the same string the badges spell out, so "google" finds the
          // Google accounts and the column groups them rather than ordering by a raw field.
          signin: (u) => signInLabel(u).toLowerCase(),
          joined: (u) => new Date(u.created_at).getTime(),
        }}
        renderRow={(u) => {
          const wa = toWhatsAppLink(u.mobile);
          return (
            <>
              <button onClick={() => nav(`/admin/users/${u.id}`)} data-testid={`open-user-${u.id}`}
                      className="text-sm text-white truncate pt-1.5 text-left hover:text-[#CBA96C] transition-colors">
                {u.name}
              </button>
              <div className="text-xs text-[#A0AABF] truncate pt-1.5">{contactEmail(u)}</div>
              <div className="text-xs text-[#A0AABF] pt-1.5 flex items-center gap-1.5">
                <span>{u.mobile || "—"}</span>
                {wa && (
                  <a href={wa} target="_blank" rel="noopener noreferrer" title={`WhatsApp ${u.mobile}`}
                     className="text-[#25D366] hover:opacity-80 shrink-0"><MessageCircle className="w-3.5 h-3.5"/></a>
                )}
              </div>
              <div className="pt-1" data-testid={`user-signin-${u.id}`}><SignInBadges user={u}/></div>
              <DateTimeCell value={u.created_at}/>
            </>
          );
        }}
      />
    </div>
  );
}
